module.exports = __webpack_public_path__ + "static/media/team6.057b9c25.jpg";